module.exports = __webpack_public_path__ + "static/media/download.e2245293.svg";